import { render, staticRenderFns } from "./baixa.vue?vue&type=template&id=316ef558"
import script from "./baixa.vue?vue&type=script&lang=js"
export * from "./baixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports